module.exports = {
  // JCRing成员页
  JCRing_member: {
    //首页
    index1: "Health Community",
    index2: "Gesundheitsgruppe",
    index3: "Mitglied",
    index4: "Eine neue Gruppe erstellen",
    index5: "Meine Gruppe",
    index6: "Warnungseinstellungen",
    index7: "Sorge für die Gesundheit deiner Liebsten",
    index8: "Keine Gruppen",
    index9: "Mitglieder",
    index10: "Per Handy/E-Mail/QR-Code oder WhattsApp zum Beitritt einladen",

    //创建群组
    addgroup1: "Gruppenname",
    addgroup2: "Gruppentyp",
    addgroup3: "Bitte eingeben",
    addgroup4: "Familiengruppe",
    addgroup5: "Unternehmensgruppe",
    addgroup6: "Andere Gruppe",
    addgroup7: "Krankenhausgruppe",
    addgroup8: "Schulgruppe",
    addgroup9: "Ja",
    addgroup10: "Nein",
    addgroup11: "Eine neue Gruppe erstellen",
    addgroup12: "Gruppenname existiert bereits",

    //成员列表
    memberlist1: "Mitgliederliste",
    memberlist2: "haben",
    memberlist3: "Anomalien",
    memberlist4: "Normal",
    memberlist5: "Ein Mitglied hinzufügen",
    memberlist6: "Löschen",
    memberlist7: "Keine Mitglieder",
    memberlist8: "loading...",
    memberlist9: "Sind Sie sicher, dass Sie die Gruppe auflösen wollen?",
    memberlist10: "Erfolgreich gelöscht",
    memberlist11: "Erfolgreich gespeichert",
    memberlist12: "Bearbeiten",
    memberlist13: "Ablehnen",
    memberlist14: "Gesundheitsstatistiken",
    memberlist15: "Normal",
    memberlist16: "Abnormal",
    memberlist17: "mehr Details",
    memberlist18: "Keine Daten für gestern",
    memberlist19: "gestern",
    memberlist20: "Einfach einladen",
    memberlist21: "um der Gruppexxx beizutreten, bitte bestätigen!",

    //修改成员
    updatemember1: "Profil",
    updatemember2: "Ändern",
    updatemember3: "Alter Spitzname",
    updatemember4: "Nickname ändern",

    //健康数据
    healthdata1: "Gesundheit",
    healthdata2: "Gesundheitsdaten",
    healthdata3: "So",
    healthdata4: "Mo",
    healthdata5: "Di",
    healthdata6: "Mi",
    healthdata7: "Do",
    healthdata8: "Fr",
    healthdata9: "Sa",
    healthdata10: "Herzfrequenz",
    healthdata11: "HRV",
    healthdata12: "Systolisch",
    healthdata13: "Diastolisch",
    healthdata14: "Körpertemperatur",
    healthdata15: "SpO2",
    healthdata16: "Schlaf",
    healthdata17: "Stress",
    healthdata18: "Cholesterin",
    healthdata19: "Triglyceride",
    healthdata20: "LDL-C",
    healthdata21: "HDL-C",
    healthdata22: "Blutzucker",
    healthdata23: "Vor der Mahlzeit",
    healthdata24: "Nach der Mahlzeit",
    healthdata25: "VO2 Max",
    healthdata26: "Atemwege",
    healthdata27: "Schritte",
    healthdata28: "Schritte",
    healthdata29: "Kalorien",
    healthdata30: "kcal",
    healthdata31: "Entfernung",
    healthdata32: "km",
    healthdata33: "Tempo",
    healthdata35: "″/KM",
    healthdata36: "′",
    healthdata37: "Gesundheitsbericht generieren",
    healthdata38: "Aktivitätsdaten",
    healthdata39: "Warnung",
    healthdata40: "Nicht autorisiert",
    healthdata41: "Bearbeiten",
    healthdata42: "Löschen",
    healthdata43: "E-Mail: ",
    healthdata44: "Telefon: ",
    healthdata45: "Löschen bestätigen?",
    healthdata46: "Zukünftige Daten können nicht angezeigt werden",
    healthdata47: "Heute",

    //邀请成员
    addmember1: "Mitglied einladen",
    addmember2: "Mitgliedskonto hinzufügen",
    addmember4:
      "Durch das 'Mitgliedskonto' können Sie die Gesundheitsdaten von Mitgliedern anzeigen und Alarmdatumsbereiche festlegen, um die Gesundheit der Mitglieder besser zu überwachen",
    addmember5: "Mehr erfahren",
    addmember6: "Mitglieder der Gesundheitsgruppe",
    addmember7: "Einladen",
    addmember8: "Beitreten",
    addmember9: "Einladen per QR-Code",
    addmember10: "Einladen über WeChat",
    addmember11: "Laden Sie ein, um der Gruppe über QR-Code beizutreten",
    addmember12: "Laden Sie ein, um der Gruppe über WeChat beizutreten",
    addmember13: "Einladen über Telefonnummer/E-Mail",
    addmember14:
      "Laden Sie ein, um der Gruppe über Telefonnummer/E-Mail beizutreten",
    addmember15:
      "Laden Sie Mitglieder ein, um deren Gesundheitszustand zu verstehen",
    addmember16: "Einladung senden",
    addmember17: "Gesendet",
    addmember18: "Ausstehende Bestätigung",
    addmember19: "Ich bin beigetreten",
    addmember20: "Jetzt teilen",
    addmember21: "Bild speichern",
    addmember22: "Ich habe abgelehnt",
    addmember23: "Ich habe verlassen",
    addmember24: "Die andere Partei hat verlassen",
    addmember25: "Die andere Partei hat abgelehnt",
    addmember26: "Die andere Partei hat beigetreten",
    addmember27: "Andere Hinzufügemethoden",

    // 群组二维码
    code1: "Gruppen- QR-Code",
    code2: "Health Community",
    code3:
      "Der QR-Code ist 5 Minuten gültig, bitte scannen Sie ihn rechtzeitig",

    //群组邀请
    invide1: "Gruppeneinladung",
    invide2: "Mitgliedergesundheit",
    invide3:
      "Sie sind eingeladen, der Gruppe beizutreten, bitte bestätigen Sie!",
    invide4: "Der Gruppe beitreten？",
    invide5:
      "Für die Datensicherheit überprüfe bitte die Gruppeninformationen, bevor du der Gruppe beitrittst",
    invide6:
      "Nachdem du der Gruppe beigetreten bist, kannst du dem jeweiligen Mitglied erlauben, deine Gesundheitsdaten einzusehen",

    //分享健康数据设置
    sethealthdata1: "Einstellung der Gesundheitsdaten",
    sethealthdata2: "Bestätigen",
    sethealthdata3: "Bitte einen Spitznamen festlegen",
    sethealthdata4: "Alle zulassen",
    sethealthdata5: "Spitznamen festlegen",
    sethealthdata6: "Speichern",
    sethealthdata7: "Bitte eingeben",
    sethealthdata8: "Bitte Bildformat hochladen",
    sethealthdata9: "Bitte Spitznamen und Avatar festlegen",
    sethealthdata10: "Bitte Avatar festlegen",
    sethealthdata11: "Die Spitznamenlänge beträgt 1-8 Zeichen",

    // 设置数据区间
    setscope1: "Herzfrequenz-Alarm",
    setscope2: "Körpertemperatur-Alarm",
    setscope3: "Schlafalarm",
    setscope4: "Fötale Herzfrequenz",
    setscope5: "Nüchtern-Blutzucker",
    setscope6: "Postprandiale Blutzuckerwerte",
    setscope7: "SpO2-Alarm",
    setscope8: "Männliche Harnsäure",
    setscope9: "Weibliche Harnsäure",
    setscope10: "Systolisch",
    setscope11: "Diastolisch",
    setscope12: "Hoch",
    setscope13: "Niedrig",
    setscope14: "Alert-Einstellung",
    setscope15: "Erfolgreich eingestellt",
    setscope16: "Zu viel",
    setscope17: "Zu wenig",
    setscope18: "Alarm",

    //下载页
    onload1: "Klick",
    onload2: "Gruppe beitreten",
    onload3: "Mit Browser öffnen",
    onload4: "Bestätigen",
    onload5: "Jeden Tag Gesundheit genießen",
    onload6: "Kostenloser Download im App Store",
    onload7: "Kostenloser Download im App Store",
    onload8: "Der Link ist abgelaufen",
    onload9: "Der QR-Code ist abgelaufen",
    onload10: "Erfolgreich beigetreten",

    // 待处理
    pending1: "Akzeptieren",
    schwebend2: "Ablehnen",
    pending3: "Einladung erneut senden",
    pending4: "Keine Daten",
    pending5: "Einladung bereits verschickt, bitte auf Bestätigung warten",
    pending6: "OK",
    pending7: "exit",

    guide1: "Bitte erstelle eine Gesundheitsgruppe und benenne sie.",
    guide2:
      "Sie können die Gesundheitsdaten der Gruppenmitglieder überprüfen und auch neue Mitglieder einladen, dieser Gesundheitsgruppe beizutreten.",
    guide3:
      "Sie können neue Mitglieder per QR-Code-Scan, WhattsApp, Handy oder E-Mail einladen. Sobald das neue Mitglied der Gruppe beitritt, können Sie seine/ihre Gesundheitsdaten überprüfen",
    guide4:
      "Sie können den Gesundheitszustand der Gruppenmitglieder überprüfen und ihre abnormen Daten einsehen",
    guide5: "Weiter",
    guide6: "OK",
    guide7: "Überwarnung",

    invite1: "Gemeinsam über Handy/E-Mail",
    invite2: "Bitte Konto eingeben",
    invite3: "Bitte Telefonnummer eingeben",
    invite4: "Bitte E-Mail-Adresse eingeben",
    invite5: "Geben Sie die richtige Telefonnummer ein",
    invite6: "Geben Sie die richtige E-Mail ein",
    invite7: "Bin der Gruppe bereits beigetreten",
    invite8: "Benutzer existiert nicht",
    invite9: "Bitte Land oder Region auswählen",
    invite10: "Bitte Suchbegriff eingeben",
    invite11: "Benutzer bestätigen",
    invite12: "Einladen",
    invite13: "Bitte auswählen"
  },

  // AI H5页面
  JCRingAI: {
    index: "Hallo,",
    index1: "Hier sind Ihre wöchentlichen Gesundheits-Insights.",
    index2: "Woche",
    index3: "Monat",
    index4: "Gesundheitsindex",
    index5: "Schlafindex",
    index6: "Vitalitätsindex",
    index7: "Gleichgewichtsindex",
    index8: "Tag",
    index9: "Jahr",
    index10: 'Wöchentliche Einblicke',
    index11: 'Monatliche Einblicke',
    index12: "Hier sind Ihre monatlichen Gesundheits-Insights.",

    sleep: 'Schlafwiederherstellung',
    sleep1: 'Schlafindex-Trend',
    sleep2: 'Schlafindex-Trend',
    sleep3: 'Der Schlafindex ist ein Indikator zur Beurteilung Ihrer Schlafgesundheit, berechnet auf der Grundlage verschiedener Metriken wie Gesamtschlafdauer, Schlafeffizienz, Einschlafzeit, Schlafherzfrequenz, Schlafsauerstoffgehalt und HRV usw.',
    sleep4: 'Ihr Schlafindex ist',
    sleep5: 'Schlafübersicht',
    sleep6: 'Die durchschnittliche Schlafdauer beträgt',
    sleep7: 'Schlafphasen',
    sleep8: 'Durchschnittliche Dauer',
    sleep9: 'Durchschnitt %',
    
    sleep11: 'Nickerchen',
    sleep12: 'Wach',
    sleep13: 'REM',
    sleep14: 'Leichter Schlaf',
    sleep15: 'Tiefer Schlaf',
    sleep16: 'Besetzt % der gesamten Woche',
    sleep17: 'Die Gesamtschlafdauer beträgt',
    sleep18: 'Die durchschnittliche Schlafleistung beträgt',
    sleep19: '%, Durchschnittliche Einschlafzeit beträgt',
    sleep20: 'min',
    sleep21: 'Schlaf-Einblicke',
    sleep22: 'Ihre verbesserten Schlafdaten',
    sleep23: 'Schlafindex',
    sleep24: 'Im Vergleich zur letzten Woche',
    sleep25: 'Der monatliche Durchschnitt des Schlafindex ist',
    sleep26: 'Schlafdauer',
    sleep27: 'Einschlafzeit',
    sleep28: 'Der monatliche Durchschnitt der Einschlafzeit ist',
    sleep29: 'Verbesserungsbereiche',
    sleep30: 'Schlafeffizienz',
    sleep31: 'Die monatliche Schlafeffizienz ist',
    sleep32: 'Wie verbessert man die Schlafeffizienz?',
    sleep33: 'Monatliche Schlaf-Einblicke',

    Expend: 'Aktivität',
    Expend1: 'Aktivitätsindex-Trend',
    Expend2: 'Aktivitätsindex-Trend',
    Expend3: 'Der Aktivitätsindex ist ein Indikator zur Bewertung Ihres Trainingsstatus, der auf verschiedenen Kennzahlen wie täglichen Schritten, Entfernung, Kalorien und Trainingsvolumen basiert.',
    Expend4: 'Der wöchentliche Durchschnitt des Aktivitätsindex ist',
    Expend5: 'Aktivitätsübersicht',
    Expend6: 'Durchschnittliche Schritte sind',
    Expend7: ', durchschnittliche Entfernung ist',
     Expend8: 'km, Kalorien sind',
     Expend9: 'kcal',
    Expend10: 'Typ/Datum',
    Expend11: 'Schritte',
    Expend12: 'Kcal',
    Expend13: 'Entfernung',
    Expend14: 'Sie haben 5 Tage, um das Schrittziel zu erreichen',
    Expend15: ', 5 Tage, um das Kalorienziel zu erreichen',
    Expend16: ', 5 Tage, um das Entfernungsziel zu erreichen',
    Expend17: 'Aktivitätseinblicke',
    
    Expend18: 'Aktivitätsindex',
    Expend19: 'Der monatliche Durchschnittswert des Aktivitätsindex beträgt',
    Expend20: 'Durchschnittliche Schritte',
    Expend21: 'Die monatliche Durchschnittszahl der Schritte beträgt',
    Expend22: 'Durchschnittliche Kalorien',
    Expend23: 'Die monatliche Durchschnittszahl der Kalorien beträgt',
    Expend24: 'Kcal',
    Expend25: 'Durchschnittliche Entfernung',
    Expend26: 'Die monatliche Durchschnittsdistanz beträgt',
    Expend27: 'km',
    Expend28: 'Wie kann man die Aktivitätsdaten verbessern?',
    Expend29: 'Aktivitätseinblicke',

    Pressure: 'Gleichgewicht',
    Pressure1: 'Trend des Gleichgewicht-Index',
    Pressure2: 'Balance Index Trend',
    Pressure3: 'Der Balance-Index ist ein Indikator zur Bewertung Ihres Stressstatus, berechnet anhand verschiedener Kennzahlen wie täglichem Stress, HRV, Stressreaktion und Erholungsindex.',
    Pressure4: 'Der durchschnittliche Vitalitätsindex beträgt',
    Pressure5: 'Der Balance-Index bleibt im Allgemeinen stabil, zeigt jedoch erhebliche Schwankungen, die mit Ihrem emotionalen Zustand zusammenhängen können. Es wird empfohlen, Stressbewältigungstechniken wie Meditation und tiefes Atmen zu erlernen, um Emotionen zu regulieren und körperliche sowie geistige Gesundheit aufrechtzuerhalten.',
    Pressure6: 'Überblick über das Gleichgewicht',
    Pressure7: 'Der durchschnittliche Stress ist',
    Pressure8: 'Der durchschnittliche Stressreaktion ist',
    Pressure9: 'Der durchschnittliche Erholungsindex ist',
    Pressure10: 'Stress',
    Pressure11: 'Stressreaktion',
    Pressure12: 'Erholungsindex',
    Pressure13: 'Balance-Einblicke',

    Pressure14: 'Ihre verbesserten Balance-Daten',
    Pressure15: 'Balance-Index',
    Pressure16: 'Der monatliche Stressreaktion ist',
    Pressure17: 'Durchschnittlicher Stress',
    Pressure18: 'Der monatliche Durchschnittsstress ist',
    Pressure19: 'Wie man Stress abbaut?',
    Pressure20: 'Einblicke in Balance und Erholung?',

    Health: 'Kardiovaskuläre Gesundheit',
    Health1: 'Ihr wöchentlicher Herzfrequenztrend',
    Health2: 'Durchschnittliche Herzfrequenz beträgt',
    Health3: 'bpm',
    Health4: 'Ihr wöchentlicher Blutoxygentrend',
    Health5: 'Wöchentlicher Durchschnitt des Blutoxygengehalts ist',
    Health6: 'Ihr wöchentliches Diabetesrisiko',
    Health7: 'Wöchentliche Diabetesrisikobewertung',
    Health8: 'Tage',
    Health9: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],

    Health10: 'Ihre normalen Gesundheitsdaten',
    Health11: 'Durchschnittliche Herzfrequenz',
    Health12: 'Monatlicher Durchschnitt der Herzfrequenz beträgt',
    Health13: 'Durchschnittlicher SpO2-Wert',
    Health14: 'Monatlicher Durchschnittswert von SpO2 beträgt',
    Health15: 'Ihre abnormalen Gesundheitsdaten',
    Health16: 'Durchschnittliche HRV',
    Health17: 'Monatlicher Durchschnitt der HRV beträgt',
    Health18: 'ms',
    Health19: 'Wie kann man die HRV verbessern?',
        


























 }
};



// WEBPACK FOOTER //
// ./src/lang/de.js